import DefaultLayout from '~pages/layouts/DefaultLayout.vue'
import MainHome from '~pages/contents/main/MainHome.vue'
import OnAir from '~pages/contents/main/OnAir.vue'
import Enter from '~pages/contents/main/Enter.vue'
import SurveyConfirm from '~pages/contents/main/SurveyConfirm.vue'
import Faq from '~pages/contents/main/Faq.vue'
import Forum from '~pages/contents/main/Forum.vue'
import PageNotFound from '~pages/contents/error/PageNotFound.vue'
import Shutdown from '~pages/contents/error/Shutdown.vue'
import PtptConfmTyp from '~pages/contents/main/PtptConfmTyp.vue'
import Classnow from '~pages/contents/main/Classnow.vue'
import MemberSsoInfo from '~pages/contents/main/MemberSsoInfo.vue'
import Oauth2Info from '~pages/contents/main/OauthInfo.vue'
import PanoptoSsoProc from '~pages/contents/main/PanoptoSsoProc.vue'
import Guide from '~pages/contents/guide/MobGuide.vue'
import PanoptoPlayer from '~pages/contents/main/PanoptoPlayer.vue'
import Privacy from '~pages/contents/guide/Privacy.vue'
import InquiryPopup from '~pages/contents/main/InquiryPopup.vue'
import CommonPopup from '~pages/contents/main/CommonPopup.vue'
import Template from '~pages/contents/main/Template.vue'
import { isEmpty } from 'lodash'

var defaultRoutes = [{
  path: '/',
  name: 'index',
  meta: {
    authorized: false
  },
  component: DefaultLayout,
  children: [{
    path: '',
    name: 'index',
    components: {
      content: MainHome
    },
    meta: {
      authorized: false,
      mainClass: 'container main-container',
      isEnter: true
    }
  },
  {
    path: 'onAir',
    name: 'onAir',
    components: {
      content: OnAir
    },
    meta: {
      authorized: false,
      menuSeq: 2,
      isContact: false
    }
  },
  {
    path: 'enter',
    name: 'enter',
    components: {
      content: Enter
    },
    meta: {
      authorized: true,
      menuSeq: 2
    }
  },
  {
    path: 'classnow',
    name: 'classnow',
    components: {
      content: Classnow
    },
    meta: {
      authorized: true,
      menuSeq: 2,
      isHeaderImg: false
    }
  },
  {
    path: 'surveyConfirm',
    name: 'surveyConfirm',
    components: {
      content: SurveyConfirm
    },
    meta: {
      authorized: false,
      menuSeq: 3,
      isContact: false
    }
  },
  {
    path: 'faq',
    name: 'faq',
    components: {
      content: Faq
    },
    meta: {
      authorized: false,
      menuSeq: 4,
      isContact: false
    }
  },
  {
    path: 'forum',
    name: 'forum',
    components: {
      content: Forum
    },
    meta: {
      authorized: false,
      menuSeq: 5,
      isContact: false
    }
  },
  {
    path: '/ptptConfmTyp/:wepApcId',
    name: 'ptptConfmTyp',
    components: {
      content: PtptConfmTyp
    },
    meta: {
      authorized: false
    }
  },
  {
    path: '/memberSsoInfo',
    name: 'memberSsoInfo',
    components: {
      content: MemberSsoInfo
    },
    meta: {
      authorized: false
    }
  },
  {
    path: '/oauth2',
    name: 'oauth2',
    components: {
      content: Oauth2Info
    },
    meta: {
      authorized: false
    }
  },
  {
    path: '/panoptoSso',
    name: 'panoptoSso',
    components: {
      content: PanoptoSsoProc
    },
    meta: {
      authorized: false
    }
  }
  ],
  props: true
},
{
  path: '/panoptoPlayer',
  name: 'poanoptoPlayer',
  component: PanoptoPlayer
},
{
  path: '*',
  redirect: {
    name: 'error'
  }
},
{
  path: 'error',
  name: 'error',
  component: PageNotFound
},
{
  path: '/guide',
  name: 'Guide',
  component: Guide
},
{
  path: '/privacy',
  name: 'Privacy',
  component: Privacy
},
{
  path: '/inquiryPopup',
  name: 'InquiryPopup',
  component: InquiryPopup
},
{
  path: '/commonPopup/:obj',
  name: 'CommonPopup',
  component: CommonPopup
},
{
  path: '/template/:fileNm',
  name: 'template',
  component: Template
}
]

export default {
  generateRouter (Router) {
    return new Promise((resolve, reject) => {
      let httpObj = window.vue.getInstance('http')
      console.log('window.location.hostname', window.location.hostname)
      let dmnNm = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : (':' + window.location.port))
      if (window.location.pathname === '/' || window.location.pathname === '') {
        dmnNm += '/'
        httpObj.mmp.getPathNm(undefined, {dmnNm: dmnNm}).then((getProInfoResponse) => {
          if (getProInfoResponse && getProInfoResponse.data !== undefined &&
            getProInfoResponse.data.data !== undefined && !isEmpty(getProInfoResponse.data.data) && getProInfoResponse.data.status === 'OK') {
            let info = getProInfoResponse.data.data
            window.location.href = dmnNm + info.contextPath
          } else {
            defaultRoutes[0].children = []
            defaultRoutes[0].redirect = {
              name: 'error'
            }

            let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, true)
            window.vue.setInstance('router', router)
            resolve()
          }
        }).catch(error => {
          console.log(error)
          defaultRoutes[0].children = []
          defaultRoutes[0].redirect = {
            name: 'error'
          }

          let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, true)
          window.vue.setInstance('router', router)
          resolve()
        })
      } else {
        dmnNm += window.location.pathname
        let mltlnCd = 'undefined'
        if (navigator.language != null) {
          mltlnCd = navigator.language
        } else {
          mltlnCd = navigator.userLanguage
        }
        mltlnCd = mltlnCd.toLowerCase().substring(0, 2)
        console.log('rootRoutes dmnNm : ' + dmnNm)
        // 대표언어 처리
        httpObj.mmp.mainContext(undefined, { dmnNm: dmnNm, mltlnCd: mltlnCd }).then((getProInfoResponse) => {
          let basePath = ''
          if (getProInfoResponse && getProInfoResponse.data !== undefined &&
                    getProInfoResponse.data.data !== undefined && !isEmpty(getProInfoResponse.data.data) && getProInfoResponse.data.status === 'OK') {
            let info = getProInfoResponse.data.data
            if (info.activeYn === 'Y') {
              basePath = isEmpty(info.contextPath) ? '' : ('/' + info.contextPath)
              // 다국어 처리
              if (basePath !== window.vue.getStore('mmpAuth').state.basePath) {
                window.vue.getStore('root').commit('LOG_OUT')
                window.vue.getStore('token').commit('DELETE')
                window.vue.getStore('mmpAuth').commit('CLEAR_AUTO_LOGIN')
                localStorage.setItem('language', info.mltlnCd)
              }
              let router = Router.createInstance(defaultRoutes, basePath, this.checkAuthorizeRouter, true)
              window.vue.setInstance('router', router)
              resolve()
              // time zone 셋팅
              // this.$utils.common.setTimeZone('Asia/Seoul')
              // footer 처리
              // 다국어 처리 확인 필요 타임존
              // window.vue.setDefault('Asia/Seoul')
              let isMain = info.isMain

              if (isMain === 'Y') {
                window.vue.getStore('mmpAuth').commit('SET_IS_MAIN', true)
              } else {
                window.vue.getStore('mmpAuth').commit('SET_IS_MAIN', false)
              }

              window.vue.getStore('mmpAuth').commit('SET_SAVE_ID', info.wepId)
              window.vue.getStore('mmpAuth').commit('SET_BASE_PATH', basePath)
              let wepSets = {'ptptAplStartDtm': info.ptptAplStartDtm, 'ptptAplEndDtm': info.ptptAplEndDtm, 'mocktUseYn': info.mocktUseYn, 'mocktStartDtm': info.mocktStartDtm, 'mocktEndDtm': info.mocktEndDtm, 'videoTrnsStartDtm': info.videoTrnsStartDtm, 'videoTrnsEndDtm': info.videoTrnsEndDtm, 'tmpltTyp': info.tmpltTyp, 'videoTrnsTyp': info.videoTrnsTyp, 'mocktWepKeyId': info.mocktWepKeyId, 'wepKeyId': info.wepKeyId, 'ptptAplTyp': info.ptptAplTyp, 'gaCd': info.gaCd, 'gtmCd': info.gtmCd, 'wepNm': info.wepNm}
              window.vue.getStore('mmpAuth').commit('SET_IS_WEPSETS', wepSets)
            } else {
              console.log('Not operating period')
              defaultRoutes[1] = {
                path: '*',
                redirect: {
                  name: 'shutdown'
                }
              }

              defaultRoutes[2] = {
                path: 'shutdown',
                name: 'shutdown',
                component: Shutdown
              }

              defaultRoutes[0].children = []
              defaultRoutes[0].redirect = {
                name: 'shutdown'
              }

              let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, true)
              window.vue.setInstance('router', router)
              resolve()
            }
          } else {
            defaultRoutes[0].children = []
            defaultRoutes[0].redirect = {
              name: 'error'
            }

            let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, true)
            window.vue.setInstance('router', router)
            resolve()
          }
        }).catch(error => {
          console.log(error)
          defaultRoutes[0].children = []
          defaultRoutes[0].redirect = {
            name: 'error'
          }

          let router = Router.createInstance(defaultRoutes, '', this.checkAuthorizeRouter, true)
          window.vue.setInstance('router', router)
          resolve()
        })
      }
    })
  },
  getErrorRoutes: function () {
    defaultRoutes[0].children = []
    defaultRoutes[0].redirect = {
      name: 'error'
    }

    return defaultRoutes
  }
}



// WEBPACK FOOTER //
// ./src/config/router/rootRoutes.js